import { extensions } from '../../extensions/Extensions';
import { MeshPipe } from './shared/MeshPipe';

extensions.add(MeshPipe);
